import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import ModalWithText from 'components/new_ui/WaitLayers/ModalWithText';

import { Link, useNavigate } from 'react-router-dom';
import routes from 'app/routes';
import Alert from 'components/new_ui/Alerts/alert';

import actions from 'components/Managers/Coaches/Actions';

export default function Footer({ coaches, removeCoachesAfterImport }) {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const onImport = () => {
    setLoader(true);
    actions.manualImport(coaches, (data) => {
      const status = removeCoachesAfterImport(data);

      const coachesWithEmails = coaches.map((item) => {
        const record = data.find((dataItem) => dataItem.email === item.email || item.email === dataItem.raw_email);

        return {
          ...item,
          email: record ? record.email : item.email,
        };
      });

      setLoader(false);
      if (status) {
        navigate(routes.managers.coaches.successImport, { state: { coaches: coachesWithEmails } });
      } else {
        Alert({
          title: 'Import Coaches',
          text: 'Looks like some of the coaches on the list have errors. Please, fix them and try again.',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  return (
    <>
      <footer>
        <Link
          to={routes.managers.coaches.index}
          className="btn btn-outline-primary"
        >
          Cancel
        </Link>

        <Button
          className={coaches.length === 0 ? 'disabled' : ''}
          onClick={onImport}
        >
          Import
        </Button>
      </footer>

      <ModalWithText show={loader} text="Please, wait. We are processing your data..." />
    </>
  );
}

Footer.propTypes = {
  removeCoachesAfterImport: PropTypes.func.isRequired,
  coaches: PropTypes.arrayOf(PropTypes.object),
};

Footer.defaultProps = {
  coaches: null,
};
